var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChecklistIcon(_ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 0H2C0.9 0 0 0.9 0 2V16C0 17.1 0.9 18 2 18H18C19.1 18 20 17.1 20 16V2C20 0.9 19.1 0 18 0ZM7 14H4C3.45 14 3 13.55 3 13C3 12.45 3.45 12 4 12H7C7.55 12 8 12.45 8 13C8 13.55 7.55 14 7 14ZM7 10H4C3.45 10 3 9.55 3 9C3 8.45 3.45 8 4 8H7C7.55 8 8 8.45 8 9C8 9.55 7.55 10 7 10ZM7 6H4C3.45 6 3 5.55 3 5C3 4.45 3.45 4 4 4H7C7.55 4 8 4.45 8 5C8 5.55 7.55 6 7 6ZM16.7 8.12L13.53 11.29C13.14 11.68 12.5 11.68 12.11 11.29L10.7 9.87C10.31 9.48 10.31 8.85 10.7 8.46C11.09 8.07 11.72 8.07 12.11 8.46L12.82 9.17L15.29 6.7C15.68 6.31 16.31 6.31 16.7 6.7L16.71 6.71C17.09 7.1 17.09 7.74 16.7 8.12Z",
    fill: "#757575"
  })));
}

export default SvgChecklistIcon;